import React from 'react';
import TicketDetailSection from '../../../sections/AdminDashboard/Support/TicketDetail';

const TicketDetail = () => {
  return <TicketDetailSection />;
};

export default TicketDetail;
